<template>
  <div class="home-page" @scroll="handleScroll">
    <!-- Background Animation -->
    <ScrollAnimation 
      :isNavBarVisible="isNavBarVisible" 
      :isSidePanelOpen="panelType === 'projectInfo' && !isMobile" 
    />

    <!-- Mobile Header -->
    <div class="mobile-header" v-if="isMobile">
      <div class="mobile-header-content">
        <div class="mobile-menu" @click="toggleMobileNav">
          <div class="hamburger-icon">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <span class="menu-text">MENU</span>
        </div>
      </div>
    </div>

    <!-- Mobile Navigation Panel -->
    <div
      class="mobile-nav-overlay"
      v-if="isMobile && isMobileNavOpen"
      @click="closeMobileNav"
    ></div>
    <div
      class="mobile-nav-panel"
      :class="{ 'nav-open': isMobileNavOpen }"
      v-if="isMobile"
    >
      <div class="nav-close-btn" @click="closeMobileNav">×</div>
      <div class="nav-content">
        <router-link
          to="/"
          @click="closeMobileNav"
          class="nav-item"
          :class="{ active: $route.name === 'Home' }"
        >
          <img src="/icons/home.svg" alt="Home" /> Home
        </router-link>
        <router-link
          to="/project-info"
          @click="closeMobileNav"
          class="nav-item"
          :class="{ active: $route.name === 'ProjectInfo' }"
        >
          <img src="/icons/info.svg" alt="Project Info" /> Project Info
        </router-link>
        <router-link
          to="/eia"
          @click="closeMobileNav"
          class="nav-item"
          :class="{ active: $route.name === 'EIA' }"
        >
          <img src="/icons/data.svg" alt="Environmental Impacts" />
          Environmental Impacts
        </router-link>
        <!-- <router-link
          to="/3d"
          @click="closeMobileNav"
          class="nav-item"
          :class="{ active: $route.name === 'Model' }"
        >
          <img src="/icons/3d.svg" alt="3D Navigation" /> 3D Navigation
        </router-link> -->
        <div class="nav-footer">
          <div class="footer-title">Development at</div>
          <div class="footer-subtitle">Ngau Tam Mei Area</div>
          <div class="footer-disclaimer">Disclaimer</div>
        </div>
      </div>
    </div>

    <div id="title" :style="{ opacity: titleOpacity }" :class="{ 'mobile-hidden': isMobile && isPanelOpen, 'desktop-hidden': panelType === 'projectInfo' && !isMobile }">
      <div id="container">
        <h1 style="text-align: center">
          Development at <br />
          <p style="font-size: 3.54vw; font-weight: bold; padding-top: 0px">
            Ngau Tam Mei Area
          </p>
          <!-- <p
            style="
              font-size: 1.8vw;
              font-weight: bold;
              padding-top: 10px;
              text-align: right;
            "
          >
            - Feasibility Study
          </p> -->
        </h1>
        <img
          class="float-animation"
          src="/icons/scroll_down.svg"
          alt=""
          srcset=""
        />
      </div>
    </div>

    <!-- Mobile Project Info Panel -->
    <div
      class="mobile-project-panel"
      :class="{ 'panel-open': isPanelOpen }"
      v-if="isMobile"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
    >
      <div class="panel-handle"></div>
      <div class="swipe-indicator" v-if="!isPanelOpen">
        <span>Swipe down to close</span>
      </div>
      <div class="panel-content">
        <div class="panel-tabs">
          <div
            class="tab"
            :class="{ active: activeTab === 'background' }"
            @click="setActiveTab('background')"
          >
            Background
            <div
              class="tab-indicator"
              :class="{ active: activeTab === 'background' }"
            ></div>
          </div>
          <div
            class="tab"
            :class="{ active: activeTab === 'description' }"
            @click="setActiveTab('description')"
          >
            Description
            <div
              class="tab-indicator"
              :class="{ active: activeTab === 'description' }"
            ></div>
          </div>
          <div
            class="tab"
            :class="{ active: activeTab === 'benefits' }"
            @click="setActiveTab('benefits')"
          >
            Benefits
            <div
              class="tab-indicator"
              :class="{ active: activeTab === 'benefits' }"
            ></div>
          </div>
        </div>

        <div class="panel-body">
          <h2 class="panel-title">Project Background</h2>
          <div class="panel-text">
            <div
              v-if="activeTab === 'background'"
              v-html="backgroundContent"
            ></div>
            <div
              v-if="activeTab === 'description'"
              v-html="descriptionContent"
            ></div>
            <div v-if="activeTab === 'benefits'" v-html="benefitsContent"></div>
          </div>
          <button class="explore-map-btn" @click="goToMap">
            EXPLORE MAP ➜
          </button>
        </div>
      </div>
    </div>

    <!-- Desktop Components (unchanged) -->
    <!-- <ModelViewer
      :isSidePanelOpen="panelType === 'projectInfo' && !isMobile"
      :is-nav-bar-visible="isNavBarVisible && !isMobile"
      viewer-url="/gs-viewer"
    /> -->
    <SidePanelInfo
      :panel-type="panelType"
      :isSidePanelOpen="panelType === 'projectInfo' && !isMobile"
      :is-nav-bar-visible="isNavBarVisible && !isMobile"
      v-if="!isMobile"
    />

    <div id="disclaimerModal" class="modal">
      <div class="modal-content">
        <span class="modal-title">Disclaimer</span>
        <span class="close" style="display: none">&times;</span>
        <div id="disclaimerText"></div>
        <div class="modal-footer">
          <button class="confirm-button" @click="dismissDisclaimer">
            Confirm
          </button>
        </div>
      </div>
    </div>
    <div class="mobile-disclaimer" id="mobileDisclaimer">
      <div class="disclaimer-content">
        Please use a desktop browser for the optimal experience
        <span class="mobile-close" @click="closeMobileDisclaimer">&times;</span>
      </div>
    </div>
  </div>
</template>

<script>
// import ScrollAnimation from "../components/ScrollerAnimation.vue";
import SidePanelInfo from "../components/SidePanelInfo.vue";
// import ModelViewer from "../components/ModelViewer.vue";
// import ScrollAnimation from "../components/ScrollerAnimation2.vue";
import ScrollAnimation from "../components/ScrollerAnimation4.vue";

export default {
  name: "HomePage",
  components: {
    // ModelViewer,
    ScrollAnimation,
    SidePanelInfo,
  },
  props: {
    panelType: String,
    isNavBarVisible: Boolean,
  },
  watch: {
    isNavBarVisible(newVal) {
      console.log('HomePage - isNavBarVisible changed to:', newVal);
    }
  },
  data() {
    return {
      titleOpacity: 1, // New data property for dynamic opacity
      hasSeenDisclaimer: false,
      isMobile: false,
      isPanelOpen: false, // Panel should be hidden initially, show on scroll
      activeTab: "background",
      touchStartY: 0,
      touchEndY: 0,
      backgroundContent: "",
      descriptionContent: "",
      benefitsContent: "",
      isMobileNavOpen: false,
    };
  },
  methods: {
    handleScroll() {
      this.scrolledPast300 = window.scrollY > 300;
      let newOpacity = 1 - scrollY / 300;
      newOpacity = newOpacity < 0 ? 0 : newOpacity; // Ensure opacity is not less than 0
      this.titleOpacity = newOpacity;

      // Show project info panel on scroll for mobile
      if (this.isMobile && window.scrollY > 100) {
        this.isPanelOpen = true;
      } else if (this.isMobile && window.scrollY <= 100) {
        this.isPanelOpen = false;
      }
    },
    checkAndLoadDisclaimer() {
      const hasSeenDisclaimer = sessionStorage.getItem("hasSeenDisclaimer");
      if (!hasSeenDisclaimer) {
        this.loadDisclaimer();
      }
      // this.loadDisclaimer();
    },
    loadDisclaimer() {
      fetch("/text/disclaimer.html")
        .then((response) => response.text())
        .then((html) => {
          document.getElementById("disclaimerText").innerHTML = html;
          document.getElementById("disclaimerModal").style.display = "block";
          // Prevent background scrolling
          document.body.style.overflow = "hidden";
          // Add event listener to prevent scroll events on the modal background
          document
            .getElementById("disclaimerModal")
            .addEventListener("wheel", this.preventModalScroll);
          document
            .getElementById("disclaimerModal")
            .addEventListener("touchmove", this.preventModalScroll);

          // const closeBtn = document.querySelector(".close");
          // closeBtn.onclick = () => {
          //   document.getElementById("disclaimerModal").style.display = "none";
          //   sessionStorage.setItem("hasSeenDisclaimer", "true");
          // };
        })
        .catch((error) => console.error("Error loading disclaimer:", error));
    },
    dismissDisclaimer() {
      const modal = document.getElementById("disclaimerModal");
      const modalContent = modal.querySelector(".modal-content");
      modalContent.removeEventListener("scroll", this.handleModalScroll);
      // Remove scroll prevention event listeners
      modal.removeEventListener("wheel", this.preventModalScroll);
      modal.removeEventListener("touchmove", this.preventModalScroll);
      modal.style.display = "none";
      sessionStorage.setItem("hasSeenDisclaimer", "true");
      this.isDisclaimerActive = false;
      document.body.style.overflow = "auto";
    },
    closeMobileDisclaimer() {
      document.getElementById("mobileDisclaimer").style.display = "none";
      sessionStorage.setItem("hasDismissedMobileDisclaimer", "true");
    },
    showMobileDisclaimer() {
      const hasDismissed = sessionStorage.getItem("hasDismissedMobileDisclaimer");
      if (!hasDismissed && this.isMobile) {
        document.getElementById("mobileDisclaimer").style.display = "block";
      }
    },
    preventModalScroll(e) {
      // Only prevent scrolling if the target is not the disclaimer text area or its children
      const disclaimerText = document.getElementById("disclaimerText");
      if (!disclaimerText.contains(e.target)) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    handleTouchStart(e) {
      this.touchStartY = e.touches[0].clientY;
    },
    handleTouchMove(e) {
      this.touchEndY = e.touches[0].clientY;
    },
    handleTouchEnd() {
      const swipeDistance = this.touchStartY - this.touchEndY;
      const minSwipeDistance = 50;

      if (swipeDistance < -minSwipeDistance && this.isPanelOpen) {
        // Swipe down - close panel
        this.isPanelOpen = false;
      }
    },
    goToMap() {
      this.$router.push("/eia");
    },
    toggleMobileNav() {
      this.isMobileNavOpen = !this.isMobileNavOpen;
    },
    closeMobileNav() {
      this.isMobileNavOpen = false;
    },
    loadContent() {
      // Load background content
      fetch("/text/background.html")
        .then((response) => response.text())
        .then((html) => {
          this.backgroundContent = html;
        })
        .catch((error) => {
          console.error("Error loading background content:", error);
          this.backgroundContent = "Failed to load background content.";
        });

      // Load description content
      fetch("/text/description.html")
        .then((response) => response.text())
        .then((html) => {
          this.descriptionContent = html;
        })
        .catch((error) => {
          console.error("Error loading description content:", error);
          this.descriptionContent = "Failed to load description content.";
        });

      // Load benefits content
      fetch("/text/benefits.html")
        .then((response) => response.text())
        .then((html) => {
          this.benefitsContent = html;
        })
        .catch((error) => {
          console.error("Error loading benefits content:", error);
          this.benefitsContent = "Failed to load benefits content.";
        });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.checkMobile);
    this.checkMobile();
    this.checkAndLoadDisclaimer();
    this.loadContent();
    // Show mobile disclaimer if on mobile and not yet dismissed
    this.$nextTick(() => {
      this.showMobileDisclaimer();
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.checkMobile);
  },
};
</script>

<style scoped>
.home-page {
  padding-top: 12vh; /* Adjust based on your HeaderBar height */
  min-height: 200vh; /* Make the page scrollable */
  /* background-color: #be4848; */
}

/* Mobile Header */
.mobile-header {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: #00353e;
  z-index: 1000;
  padding: 0 20px;
}

.mobile-header-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
}

.mobile-title {
  color: white;
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
}

.mobile-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
}

.hamburger-icon {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-bottom: 2px;
}

.hamburger-icon span {
  width: 20px;
  height: 2px;
  background-color: white;
  border-radius: 1px;
}

.menu-text {
  font-size: 10px;
  font-family: Arial, Helvetica, sans-serif;
}

/* Mobile Navigation Panel */
.mobile-nav-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
}

.mobile-nav-panel {
  position: fixed;
  top: 0;
  right: -100%;
  width: 70%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 20px 0 0 20px;
  transition: right 0.3s ease-in-out;
  z-index: 1002;
  overflow: hidden;
}

.mobile-nav-panel.nav-open {
  right: 0;
}

.nav-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 30px;
  height: 30px;
  background-color: #00353e;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  z-index: 1003;
}

.nav-content {
  padding: 80px 30px 30px 30px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 15px 0;
  text-decoration: none;
  color: #333;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  border-bottom: 1px solid #eee;
  transition: background-color 0.3s ease;
}

.nav-item:hover {
  background-color: #f5f5f5;
}

.nav-item.active {
  background-color: #008768;
  color: white;
}

.nav-item img {
  width: 20px;
  height: 20px;
  margin-right: 15px;
}

.nav-item.active img {
  filter: brightness(0) invert(1);
}

.nav-footer {
  margin-top: auto;
  padding-top: 30px;
  text-align: center;
}

.footer-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
  font-family: Arial, Helvetica, sans-serif;
}

.footer-subtitle {
  font-size: 18px;
  font-weight: bold;
  color: #00353e;
  margin-bottom: 10px;
  font-family: Arial, Helvetica, sans-serif;
}

.footer-disclaimer {
  font-size: 12px;
  color: #999;
  text-decoration: underline;
  cursor: pointer;
  font-family: Arial, Helvetica, sans-serif;
}

/* Mobile Project Info Panel */
.mobile-project-panel {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60%;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 20px 20px 0 0;
  transform: translateY(100%); /* Panel is hidden by default */
  transition: transform 0.3s ease-in-out;
  z-index: 999;
  overflow: hidden;
}

.mobile-project-panel.panel-open {
  transform: translateY(0); /* Fully open */
}

.panel-handle {
  width: 40px;
  height: 4px;
  background-color: #ccc;
  border-radius: 2px;
  margin: 10px auto;
}

.swipe-indicator {
  text-align: center;
  padding: 10px;
  color: #666;
  font-size: 12px;
  font-family: Arial, Helvetica, sans-serif;
}

.panel-content {
  height: calc(100% - 30px);
  display: flex;
  flex-direction: column;
}

.panel-tabs {
  display: flex;
  justify-content: space-around;
  padding: 20px 20px 0 20px;
  border-bottom: 1px solid #eee;
}

.tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  color: #999;
  font-size: 14px;
  font-weight: 500;
  font-family: Arial, Helvetica, sans-serif;
  position: relative;
}

.tab.active {
  color: #00353e;
  font-weight: 600;
}

.tab-indicator {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #ccc;
  margin-top: 8px;
  transition: background-color 0.3s ease;
}

.tab-indicator.active {
  background-color: #00353e;
}

.panel-body {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.panel-title {
  color: #00353e;
  font-size: 24px;
  font-weight: bold;
  margin: 0 0 20px 0;
  font-family: Arial, Helvetica, sans-serif;
}

.panel-text {
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  margin-bottom: 30px;
  font-family: Arial, Helvetica, sans-serif;
}

.explore-map-btn {
  width: 100%;
  background-color: #00353e;
  color: white;
  border: none;
  padding: 15px 20px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  font-family: Arial, Helvetica, sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.explore-map-btn:hover {
  background-color: #004a5a;
}

/* Mobile responsive styles */
@media screen and (max-width: 768px) {
  .home-page {
    padding-top: 60px; /* Adjust for mobile header */
  }

  .mobile-header {
    display: block;
  }

  .mobile-project-panel {
    display: block;
  }

  .mobile-hidden {
    opacity: 0 !important;
    pointer-events: none;
  }

  #title {
    height: calc(100vh - 60px);
  }

  #container {
    padding: 8vh 4vw 2vw 4vw;
  }

  #title h1 {
    font-size: 6vw;
  }

  #title p {
    font-size: 4vw;
  }

  img {
    width: 15vw;
  }
}

#scrollAnimation {
  z-index: -11;
}

#title {
  font-family: Arial, Helvetica, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  color: white;
}

#container {
  display: flex;
  flex-direction: column;

  padding: 12vh 2vw 2vw 4vw;
  width: auto;
  height: auto !important;
  /* background-color: rgb(0, 0, 0); */
  color: white;
  /* text shadow */
  text-shadow: 0px 2px 8px #000000;
}

img {
  padding-top: 50px;
  align-self: center !important;
  width: 8vw;
  /* height: 2vh; */
}

#title h1 {
  font-size: 2.5vw;
  font-weight: bold;
  margin: 0;
}

#title p {
  padding-top: 24px;
  font-weight: normal;
  margin: 0;
  font: 1.8vw arial, sans-serif;
  font-style: thin;
}
.fade-out {
  opacity: 0;
}

.modal {
  display: none;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.4);
  align-items: center;
  justify-content: center;
}

.modal[style*="display: block"] {
  display: flex !important;
}

.modal-content {
  background-color: #fefefe;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  max-width: 600px;
  max-height: 70vh;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.modal-title {
  display: block;
  font-size: 1.5em;
  font-weight: bold;
  margin-bottom: 15px;
  text-align: center; /* Center only the title */
  color: #008768;
  font-family: Arial, Helvetica, sans-serif;
  flex-shrink: 0;
}

#disclaimerText {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 20px;
  padding-right: 10px;
  max-height: calc(70vh - 160px); /* Account for title and footer space */
  scrollbar-width: thin;
}

#disclaimerText::-webkit-scrollbar {
  width: 6px;
}

#disclaimerText::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

#disclaimerText::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

#disclaimerText::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  color: #aaa;
  font-size: 32px;
  font-weight: bold;
  cursor: pointer;
  line-height: 30px;
  text-align: center;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.mobile-disclaimer {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  font-family: Arial, Helvetica, sans-serif;
  /* Prevent scrolling of the background while disclaimer is shown */
  overflow: hidden;
}

.disclaimer-content {
  position: fixed;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #00353e;
  padding: 50px 40px;
  border-radius: 12px;
  color: white;
  text-align: center;
  font-size: 20px;
  line-height: 1.5;
  max-width: 85vw;
  min-width: 280px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  /* Ensure it stays above other content */
  z-index: 1001;
}

.mobile-close {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
  font-size: 32px;
  cursor: pointer;
  padding: 5px;
  text-align: center;
  line-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-close:hover {
  opacity: 0.8;
}

@media screen and (max-width: 768px) {
  .mobile-disclaimer {
    display: block; /* Show mobile disclaimer on mobile devices */
  }
}

.desktop-hidden {
  display: none !important;
}

.modal-footer {
  margin-top: 20px;
  padding: 20px 0 0 0;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
}

.confirm-button {
  background-color: #008768;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 50px;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.confirm-button:hover {
  background-color: #00606a;
}
</style>